export default {
  emit: function(evtName, evtParams = {}) {
    document.dispatchEvent(
      new CustomEvent(evtName, {
        detail: evtParams
      })
    )
  },

  on(evtName, evtCallback) {
    document.addEventListener(evtName, evtCallback)
  }
}
